<template>
    <div class='carrousel'>
        <div class='d-flex'>
            <div>
                <h1 class="filter-title ml-1  ">{{Title}} </h1>
            </div>
              
        </div>
       

            <div class="carrousel-product row mb-1 mt-3"  data-ride="carousel" data-interval="3000">
                <slot >
                    
                </slot>
                
            </div>
    </div>
</template>

<script>
    export default {
        props: {
            Title: {
                type: String,
                
            },
        },
    }
</script>

<style scoped>


.filter-title {
  font-size: 1.2rem;
  font-weight:900;
  padding-top:7%;
  font-family: 'Roboto',sans-serif;
  color:var(--main-red-black);
  text-transform:uppercase;
}

.carrousel-product {
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: baseline;
  gap: 0.1rem;
  overflow-x: auto;
  width: 100%;
  margin-bottom: 0.063rem;
  padding: 0.25rem;
}
  @media (min-width: 700px) {

.carrousel-product {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: baseline;
    gap: 0.1rem;
    overflow-x: auto;
    width: 100%;
    margin-bottom: 0.063rem;
    padding: 0.25rem;
    }
  }
</style>